/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */


const theme = {
  appearances: {
    horizontal: {
      description: 'Use horizontal to display timeline horizontally.',
      type: 'variant',
      values: [ true ]
    },
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { horizontal: true, viewport: [ 'lg', 'xl' ] },
      tokens: {
        connectorHeight: 1,
        connectorWidth: '100%',
        itemContentMarginBottom: 0,
        itemContentMarginRight: 32,
        lineItemContainerDirection: 'column',
        lineItemDirection: 'row',
        lineItemMarginBottom: 24,
        lineItemMarginRight: 0,
        timelineContainerDirection: 'row'
      }
    }
  ],
  tokens: {
    connectorHeight: '100%',
    connectorWidth: 1,
    dotBorderWidth: 2,
    dotColor: '#ffffff',
    dotWidth: 12,
    itemContentFlexSize: 1,
    itemContentMarginBottom: 32,
    itemContentMarginRight: 0,
    lineContainerFlexSize: 1,
    lineItemAlign: 'center',
    lineItemContainerDirection: 'row',
    lineItemDirection: 'column',
    lineItemMarginBottom: 0,
    lineItemMarginRight: 24,
    timelineColor: '#000000',
    timelineConnectorColor: '#000000',
    timelineContainerDirection: 'column'
  }
}
export default theme
